<div [ngbTooltip]="showTooltip ? tooltipContent : '' " openDelay="700" >
   <ng-content></ng-content>
</div>
